import { render } from "./Certificate.vue?vue&type=template&id=0a03e754&scoped=true"
import script from "./Certificate.vue?vue&type=script&lang=js"
export * from "./Certificate.vue?vue&type=script&lang=js"

import "./Certificate.vue?vue&type=style&index=0&id=0a03e754&scoped=true&lang=scss"

import exportComponent from "D:\\work\\ocs\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a03e754"]])

export default __exports__